/**
 * RsValue yanıtından value alanını okur (camelCase / PascalCase uyumlu).
 */
export const getRsValueData = <T>(response: unknown): T | null => {
  if (!response || typeof response !== 'object') {
    return null;
  }

  const rs = response as Record<string, unknown>;
  const hasError = rs.error === true || rs.Error === true;
  if (hasError) {
    return null;
  }

  const value = rs.value ?? rs.Value;
  return (value ?? null) as T | null;
};
